import { uuid } from './index';
import _ from 'lodash';
import { TreeNodeType, Direction } from './types';
// X轴的间距
const X_GAP = 140;
// Y轴的间距
const Y_GAP = 40;
// 拖拽占位的间距
const Y_DRAG_GAP = 12;
// 拖拽占位节点高度
const DRAG_NODE_HEIGHT = 16;
// 节点头部高度
const NODE_HEADER = 32;
// 合并x间距
const MERGE_X_GAP = 64;
export class Meta {
    compare;
    configKey;
    configName;
    extParam;
    processorPrefix;
    reboundRetreatPriceDiff;
    regionType;
    stockRange;
    strategyPoints;
    targetBuySell;
    values;
    children;
    type;
    mergeNode;
    preNode;
    buyAndSellType;
    constructor({ compare = null, configKey = null, configName = null, extParam = null, processorPrefix = null, reboundRetreatPriceDiff = null, regionType = null, stockRange = null, strategyPoints = null, targetBuySell = null, type = null, values = null, children = [], mergeNode = null, preNode = null, buyAndSellType = null, }) {
        this.compare = compare;
        this.configKey = configKey;
        this.configName = configName;
        this.extParam = Object.assign({
            // 按钮后增加的线能否 【添加】
            canAdd: true,
            // 合并内判断是否有增加按钮
            canInsert: true,
            // 是否隐藏增加按钮
            hiddenInsert: false,
            // 是否标红
            isError: false,
            // 是否高亮
            isHighLight: false,
            // 是否为合并的特殊节点
            isMergeNode: false,
            // 是否展开
            isOpen: true,
            // 工具配置信息
            configParams: null,
            // 菜单选项是否被禁用
            menuDisabled: false,
            // 是否可拖拽
            isDrag: false,
            // 是否在拖拽中
            isDragging: false,
            // 工具是否校验通过
            verifyStatus: false,
            // 工具是否是编辑态
            toolsIsEdit: false,
            // 收起数量
            shrinkNum: 0,
            // 是否为拖拽占位元素
            isDragElement: false,
            // 是否可拖入，仅在合并内拖动有效
            dropTop: true,
            dropBottom: true,
            errorStatus: null, // 错误状态 1 条件错误 请重新选择
        }, extParam);
        this.processorPrefix = processorPrefix;
        this.reboundRetreatPriceDiff = reboundRetreatPriceDiff;
        this.regionType = regionType;
        this.stockRange = stockRange;
        this.strategyPoints = strategyPoints;
        this.targetBuySell = targetBuySell;
        this.type = type;
        this.values = values;
        this.children = children;
        this.type = type;
        this.mergeNode = mergeNode;
        this.preNode = preNode;
        this.buyAndSellType = buyAndSellType;
    }
}
export class Node {
    id = uuid();
    // 宽度
    width;
    // 高度
    height;
    // 坐标
    coordinate;
    // meta
    meta;
    // // 前端存值
    // extParam: any
    // // 是否有添加按钮  默认为true
    // canAdd: boolean;
    // // 是否标红  默认为false
    // isError: boolean;
    // // 是否高亮  默认为false
    // isHighLight: boolean;
    constructor({ width = 240, height = 68, coordinate = [0, 0], meta = new Meta({}) }) {
        this.width = width;
        this.height = height;
        this.coordinate = coordinate;
        this.meta = new Meta(meta);
    }
}
export class Link {
    id = uuid();
    startId;
    endId;
    startAt;
    endAt;
    meta;
    // // 是否有添加按钮  默认为true
    // canAdd: boolean;
    // // 是否展开  默认为true
    // isOpen: boolean;
    // // 合并线路点击同时高亮标记id  默认为-1
    // activeId: number;
    // // 是否高亮  默认为false
    // isHighLight: boolean;
    constructor({ startId, endId, startAt = [240, 50], endAt = [0, 50], meta = null }) {
        this.startId = startId;
        this.endId = endId;
        this.startAt = startAt;
        this.endAt = endAt;
        this.meta = Object.assign({
            canAdd: true,
            dropTop: true,
            isOpen: false,
            activeId: -1,
            isHighLight: false,
            // 途径点
            stationPoint: [],
        }, meta);
    }
}
// targetArr 是否为 Arr 的子集  true-是  false-否
export function containsAll(arr, targetArr) {
    const result = targetArr.every(item => arr.includes(item));
    return result;
}
// 二维数组去重
function drop2DArrayDuplicate(arr) {
    const result = _.uniqWith(arr, _.isEqual);
    return result;
}
// 判断节点是否在 合并中
export function isNodeInMerge({ nodeId, modelPathList, nodeList }) {
    const childrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
    const childrenIds = childrenList.map(item => item.id);
    const otherPathList = modelPathList.filter(item => !item.includes(nodeId));
    let flag = false;
    for (let index = 0; index < otherPathList.length && !flag; index++) {
        const path = otherPathList[index];
        // 取交集
        const intersectionNodeIds = _.intersectionWith(childrenIds, path, _.isEqual);
        if (intersectionNodeIds.length) {
            flag = true;
        }
    }
    return flag;
}
// 判断节点所在链路后面中是否有工具为编辑态或错误
export function hasErrorToolInLink({ nodeId, modelPathList, nodeList }) {
    for (const item of modelPathList) {
        if (item.includes(nodeId)) {
            const findIndex = item.findIndex(ele => ele === nodeId);
            const inAllIndex = nodeList.findIndex(ele => ele.id === nodeId);
            const afterList = item.slice(findIndex);
            const list = nodeList.filter(ele => afterList.includes(ele.id));
            const curNodeMeta = nodeList[inAllIndex]?.meta;
            const curNodeError = inAllIndex > -1 &&
                curNodeMeta?.type === TreeNodeType.TOOLS &&
                (!curNodeMeta.configName || curNodeMeta.extParam?.toolsIsEdit);
            const has = list.some(node => node.meta.type === TreeNodeType.TOOLS &&
                (!node.meta.configName || node.meta.extParam.toolsIsEdit)) && !curNodeError;
            if (has) {
                return true;
            }
        }
    }
    return false;
}
// 根据id 获取节点
function findNodeById({ nodeId, nodeList }) {
    const node = nodeList.find(node => node.id === nodeId);
    return node || null;
}
// 根据id 获取线路
function findLinkById({ linkId, linkList }) {
    const link = linkList.find(link => link.id === linkId);
    return link || null;
}
// 根据线路 获取节点
function findNodeByLink({ link, nodeList }) {
    return {
        start: findNodeById({ nodeId: link.startId, nodeList }),
        end: findNodeById({ nodeId: link.endId, nodeList }),
    };
}
// 遍历nodeList根据nodeId，找到startId对应的其中一条link，将该link的activeId与nodeId映射
export function getNodeIdActiveMap({ nodeList, linkList }) {
    const map = new Map();
    nodeList.forEach(node => {
        const link = findLinkByStartId({ nodeId: node.id, linkList });
        const activeId = link?.meta?.activeId ?? -1;
        map.set(node.id, activeId);
    });
    return map;
}
/**
 * 设置高亮路径
 * @param param0
 */
export function lightenPath({ nodeIds, nodeList, linkList, }) {
    // 设置高亮节点
    const lightenNodeList = nodeIds.map(nodeId => {
        return {
            ...findNodeById({ nodeId, nodeList }),
        };
    });
    lightenNodeList.forEach(node => {
        node.meta && (node.meta.isHighLight = true);
    });
    // 设置高亮连线
    const endLinkList = linkList.filter(link => !!findNodeById({ nodeId: link.endId, nodeList: lightenNodeList }));
    const lightenLinkList = endLinkList.filter(link => !!findNodeById({ nodeId: link.startId, nodeList: lightenNodeList }));
    lightenLinkList.forEach(link => {
        link.meta.isHighLight = true;
    });
}
function findLinkByStartId({ nodeId, linkList }) {
    const link = linkList.find(link => link.startId === nodeId);
    return link || null;
}
// 根据结束id 获取第一个线路
function findLinkByEndId({ nodeId, linkList }) {
    const link = linkList.find(link => link.endId === nodeId);
    return link || null;
}
// 删除多余的 线路
export function cleanExtraLink({ nodeList, linkList }) {
    const nodeIdList = nodeList.map(item => item.id);
    for (let i = linkList.length - 1; i >= 0; i--) {
        const link = linkList[i];
        const nodeObj = findNodeByLink({ link, nodeList });
        const startFlag = nodeIdList.includes(nodeObj.start?.id);
        const endFlag = nodeIdList.includes(nodeObj.end?.id);
        if (!startFlag || !endFlag) {
            // 若 线路 任意一端不存在，则删除线路
            linkList.splice(i, 1);
        }
    }
}
// 获取 所有终点节点数据(y值升序)
export function getAllFinalNode({ nodeList, modelPathList }) {
    // 页面上展示的渲染节点
    const renderNodeList = initShrinkNode({
        modelPathList,
        nodeList,
    });
    if (renderNodeList.length <= 1) {
        // 仅有起始节点
        return renderNodeList;
    }
    // 收起的node集合
    const shrinkNodes = nodeList.reduce((prev, cur) => {
        if (!cur.meta.extParam.isOpen) {
            return [...prev, cur.id];
        }
        return prev;
    }, []);
    // 渲染链路
    const renderPathList = modelPathList.map(item => {
        if (item.every(ele => !shrinkNodes.includes(ele))) {
            // 不经过该节点，则不处理
            return item;
        }
        else {
            // 经过该节点，则截取该节点前的数据
            const index = item.findIndex(nodeId => shrinkNodes.includes(nodeId));
            return item.slice(0, index + 1);
        }
    });
    let finalIdList = [];
    renderPathList.forEach(path => {
        finalIdList.push(path[path.length - 1]);
    });
    finalIdList = Array.from(new Set(finalIdList));
    const finalNodeList = finalIdList.map(id => {
        return findNodeById({ nodeId: id, nodeList: renderNodeList });
    });
    finalNodeList.sort((a, b) => a?.coordinate[1] - b?.coordinate[1]);
    return finalNodeList;
}
// 判断 合并的数组存在不相邻或非尾部节点  true-校验通过  false-校验失败
export function checkMergeNodeList({ mergeNodeList, nodeList, modelPathList }) {
    if (mergeNodeList.length <= 1) {
        return;
    }
    const allFinalNodeList = getAllFinalNode({ nodeList, modelPathList });
    const allFinalNodeIds = allFinalNodeList.map(node => node.id);
    let flag = true;
    const mergeIndexList = [];
    mergeNodeList.forEach(node => {
        if (!allFinalNodeIds.includes(node.id)) {
            flag = false;
        }
        const index = allFinalNodeIds.findIndex(item => item === node.id);
        mergeIndexList.push(index);
    });
    mergeIndexList.sort((a, b) => a - b);
    for (let i = 0; i < mergeIndexList.length - 1; i++) {
        const curIndex = mergeIndexList[i];
        const nextIndex = mergeIndexList[i + 1];
        if (nextIndex - curIndex > 1) {
            flag = false;
            break;
        }
    }
    return flag;
}
/**
 * @Description: 查询子孙节点数组（包括自身）
 * @param {*} param1
 * @return {*}
 */
export function findChildrenNodeList({ nodeId, modelPathList, nodeList }) {
    const list = [];
    modelPathList.forEach(path => {
        if (path.includes(nodeId)) {
            //  当前节点所在的位置
            const index = path.findIndex(id => id === nodeId);
            const sonList = path.slice(index, path.length);
            list.push(...sonList);
        }
    });
    if (!list.length) {
        return [];
    }
    const ids = Array.from(new Set(list));
    return nodeList.filter(node => ids.includes(node.id));
}
/**
 * @Description: 获取nodeList中 最底部的y值
 * @param {*} nodeList
 * @return {*}
 */
function calcMaxY(nodeList) {
    let maxYTop = 0;
    let maxYBottom = 0;
    nodeList.forEach(node => {
        maxYTop = Math.max(maxYTop, node.coordinate[1]);
        maxYBottom = Math.max(maxYBottom, node.height + node.coordinate[1]);
    });
    return {
        top: maxYTop,
        bottom: maxYBottom,
    };
}
// 找到 传入的 modelPathList 最上方的链路
function findTopPathFromPathList({ modelPathList, nodeList }) {
    if (!modelPathList.length)
        return [];
    if (modelPathList.length === 1)
        return modelPathList[0];
    let result = modelPathList[0];
    for (let i = 1; i < modelPathList.length; i++) {
        const intersectionNodeIds = _.intersectionWith(modelPathList[i], result, _.isEqual);
        const list1 = result.filter(item => !intersectionNodeIds.includes(item));
        const list2 = modelPathList[i].filter(item => !intersectionNodeIds.includes(item));
        const min1 = list1.reduce((min, cur) => {
            const node = findNodeById({ nodeId: cur, nodeList });
            const y = node.coordinate[1];
            return Math.min(min, y);
        }, 0);
        const min2 = list2.reduce((min, cur) => {
            const node = findNodeById({ nodeId: cur, nodeList });
            const y = node.coordinate[1];
            return Math.min(min, y);
        }, 0);
        if (min2 > min1) {
            result = modelPathList[i];
        }
    }
    return result;
}
// 找到 传入的 modelPathList 最下方的链路
function findBottomPathFromPathList({ modelPathList, nodeList }) {
    if (!modelPathList.length)
        return [];
    if (modelPathList.length === 1)
        return modelPathList[0];
    let result = modelPathList[0];
    for (let i = 1; i < modelPathList.length; i++) {
        const intersectionNodeIds = _.intersectionWith(modelPathList[i], result, _.isEqual);
        const list1 = result.filter(item => !intersectionNodeIds.includes(item));
        const list2 = modelPathList[i].filter(item => !intersectionNodeIds.includes(item));
        const max1 = list1.reduce((max, cur) => {
            const node = findNodeById({ nodeId: cur, nodeList });
            const y = node.coordinate[1];
            return Math.max(max, y);
        }, 0);
        const max2 = list2.reduce((max, cur) => {
            const node = findNodeById({ nodeId: cur, nodeList });
            const y = node.coordinate[1];
            return Math.max(max, y);
        }, 0);
        if (max2 > max1) {
            result = modelPathList[i];
        }
    }
    return result;
}
// 获取当前节点合并范围内的所有链路
// function findNodeMergePathList({ nodeId, modelPathList, nodeList, linkList, nextNodeActiveId }) {
//   // const map = getNodeIdActiveMap({ nodeList, linkList })
//   const nodeIdActiveMap = getNodeIdActiveMap({ nodeList, linkList });
//   const map = new Map();
//   modelPathList.forEach(item => {
//     // 倒序遍历
//     for (let i = item.length - 1; i >= 0; i--) {
//       const activeId = nodeIdActiveMap.get(item[i]) || -1;
//       if (activeId !== -1) {
//         if (map.has(activeId)) {
//           map.set(activeId, Array.from(new Set([...map.get(activeId), ...item])));
//         } else {
//           map.set(activeId, [...item]);
//         }
//         break;
//       }
//     }
//   });
//   console.log('map', map)
// }
/**
 * @Description: 插入(增加)节点
 * @param {number} id
 * @param {any[]} modelPathList
 * @param {any[]} nodeList
 * @param {any[]} linkList
 * @return {void}
 */
export function insertNode({ nodeId, modelPathList, nodeList, linkList, width = 240, height = 68, meta = new Meta({}), }) {
    const childrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
    const node = findNodeById({ nodeId, nodeList });
    // 处理 节点
    const newX = X_GAP + node.width + node.coordinate[0];
    const isMergeNode = node.meta?.extParam?.isMergeNode;
    const newY = isMergeNode ? node.coordinate[1] - NODE_HEADER / 2 : node.coordinate[1];
    const newNode = new Node({
        width,
        height,
        coordinate: [newX, newY],
        meta: {
            ...meta,
            extParam: {
                ...meta.extParam,
                dropTop: node.meta?.extParam?.dropTop,
                canAdd: node.meta?.extParam?.canAdd,
            },
        },
    });
    /** 偏移y轴 START */
    // y坐标大于nodeId.y 的node集合
    const otherUpperNodeList = nodeList.filter(item => item.coordinate[1] <= node.coordinate[1] && item?.meta?.configKey !== 'start_node');
    // nodeY1 为 otherUpperNodeList 中 y+height 最大值
    let nodeY1Max = 0;
    otherUpperNodeList.forEach(item => {
        if (item.coordinate[1] + item.height > nodeY1Max) {
            nodeY1Max = item.coordinate[1] + item.height;
        }
    });
    if (nodeY1Max > 0) {
        const offsetY = newNode.coordinate[1] + height - nodeY1Max;
        if (offsetY > 0) {
            nodeList.forEach(item => {
                // if (item.meta?.extParam?.isMergeNode) {
                //   if (item.coordinate[1] - NODE_HEADER / 2 > node.coordinate[1]) {
                //     item.coordinate[1] += offsetY;
                //   }
                // } else {
                //   if (item.coordinate[1] > node.coordinate[1]) {
                //     item.coordinate[1] += offsetY;
                //   }
                // }
                if (item.coordinate[1] > node.coordinate[1] + NODE_HEADER / 2) {
                    item.coordinate[1] += offsetY;
                }
            });
        }
    }
    /** 偏移x轴 START */
    // 需要偏移的节点集合
    let needOffsetNodeList = [];
    // 子孙节点中的合并节点集合
    const childrenNodeListOfMerge = childrenList.filter(item => item.meta?.extParam?.isMergeNode && item.id !== nodeId);
    // 子孙节点中的合并节点id集合
    const childrenIdsOfMerge = childrenNodeListOfMerge.map(item => item.id);
    // 若子孙节点中无合并节点则所有子孙节点都需要向后偏移
    if (!childrenIdsOfMerge.length) {
        needOffsetNodeList = childrenList;
    }
    else {
        // 否则若路径了合并节点和当前节点的每条链路中，合并节点和前节点如果都有预留位置能装下新节点，那么该合并节点及它子孙节点无需向后偏移
        // 途径当前节点、当前节点的子孙节点中的合并节点 的所有链路
        const curNodeAndChildMergeNodePathList = modelPathList.filter(item => item.includes(nodeId) && item.some(ele => childrenIdsOfMerge.includes(ele)));
        // 需要过滤的合并子节点
        const needFilterMergeNodeIdList = [];
        for (const id of childrenIdsOfMerge) {
            // 途径当前节点、当前子孙合并节点 的所有链路
            const pathCurMergeNodePathList = curNodeAndChildMergeNodePathList.filter(item => item.includes(id));
            // 当前子孙合并节点的x
            const curMergeNodeX = childrenNodeListOfMerge.find(item => item.id === id)?.coordinate?.[0];
            let sameNum = 0;
            for (const item of pathCurMergeNodePathList) {
                // 当前子孙合并节点索引
                const preNodeIndex = item.findIndex(ele => ele === id) - 1;
                // 当前子孙合并节点id
                const preNodeId = item[preNodeIndex];
                // 如果每条链路中的子孙合并节点和前以一个节点的预留位置能装下新节点，则记录该合并节点
                if (curMergeNodeX -
                    (childrenList.find(ele => ele.id === preNodeId).coordinate[0] +
                        childrenList.find(ele => ele.id === preNodeId).width) >
                    X_GAP + newNode.width) {
                    sameNum++;
                }
            }
            if (sameNum === pathCurMergeNodePathList.length && sameNum !== 0) {
                needFilterMergeNodeIdList.push(id);
            }
        }
        if (!needFilterMergeNodeIdList.length) {
            needOffsetNodeList = childrenList;
        }
        else {
            // 需要过滤的合并子节点的子孙节点
            const needFilterMergeNodeChildrenIds = [];
            for (const item of needFilterMergeNodeIdList) {
                const list = findChildrenNodeList({ nodeId: item, modelPathList, nodeList });
                needFilterMergeNodeChildrenIds.push(...list.map(ele => ele.id));
            }
            needOffsetNodeList = childrenList.filter(item => !needFilterMergeNodeChildrenIds.includes(item.id));
        }
    }
    needOffsetNodeList.forEach((childNode) => {
        if (childNode.id !== nodeId) {
            // 自身节点无需向后偏移
            childNode.coordinate[0] += X_GAP + newNode.width;
            // (node.meta?.extParam?.isMergeNode ? X_GAP * 2 : X_GAP) + newNode.width;
        }
    });
    /** 偏移x轴 END */
    nodeList.push(newNode);
    /** 偏移y轴 END */
    const canAdd = node.meta.extParam.canAdd;
    const dropTop = node.meta.extParam.dropTop;
    // 处理 线路
    const newLink = new Link({
        startId: nodeId,
        endId: newNode.id,
        meta: {
            canAdd,
            dropTop,
        },
    });
    linkList.forEach(linkItem => {
        if (linkItem.startId === nodeId) {
            linkItem.startId = newNode.id;
            linkItem.startAt[0] = 240;
        }
    });
    linkList.push(newLink);
    // 处理 链路
    modelPathList.forEach(path => {
        if (path.includes(nodeId)) {
            //  当前节点所在的位置
            const index = path.findIndex(id => id === nodeId);
            path.splice(index + 1, 0, newNode.id);
        }
    });
}
/**
 * @Description: 添加 节点
 * @param {*} linkId  点击添加的 线路id
 * @param {*} modelPathList
 * @param {*} nodeList
 * @param {*} linkList
 * @return {*}
 */
export function appendNode({ linkId, modelPathList, nodeList, linkList, width = 240, height = 68, meta = new Meta({}), }) {
    const link = findLinkById({ linkId, linkList });
    const nodeObj = findNodeByLink({ link, nodeList });
    const endNode = nodeObj.end;
    const startNode = nodeObj.start;
    // 该节点的子孙节点（包括收起的）
    const childrenList = findChildrenNodeList({
        nodeId: endNode.id,
        modelPathList,
        nodeList,
    });
    // 页面上展示的渲染节点
    const renderNodeList = initShrinkNode({
        modelPathList,
        nodeList,
    });
    // 该节点的子孙节点-不包括收起的
    const renderChildrenList = findChildrenNodeList({
        nodeId: endNode.id,
        modelPathList,
        nodeList: renderNodeList,
    });
    // 在展示的子孙节点中找出y最大的
    const newX = endNode.coordinate[0];
    const maxY = calcMaxY(renderChildrenList);
    const newY = Y_GAP + maxY.bottom;
    const newNode = new Node({
        width,
        height,
        coordinate: [newX, newY],
        meta,
    });
    nodeList.forEach(nodeItem => {
        // 子孙节点y不变，剩余节点中y比（展示的子孙节点中找出y最大的）大的增加偏移量
        if (!childrenList.some(ele => ele.id === nodeItem.id)) {
            if (nodeItem.meta?.extParam?.isMergeNode) {
                if (nodeItem.coordinate[1] - NODE_HEADER / 2 > maxY.top) {
                    nodeItem.coordinate[1] += Y_GAP + newNode.height;
                }
            }
            else {
                if (nodeItem.coordinate[1] > maxY.top) {
                    nodeItem.coordinate[1] += Y_GAP + newNode.height;
                }
            }
        }
    });
    nodeList.push(newNode);
    // 处理 线路
    const newLink = new Link({
        startId: startNode.id,
        endId: newNode.id,
        meta: {
            stationPoint: JSON.parse(JSON.stringify(link.meta?.stationPoint ?? [])),
        },
    });
    linkList.push(newLink);
    // 处理 链路
    const newPathList = [];
    modelPathList.forEach(path => {
        if (path.includes(startNode.id)) {
            //  当前节点所在的位置
            const index = path.findIndex(id => id === startNode.id);
            newPathList.push([...path.slice(0, index + 1), newNode.id]);
        }
    });
    modelPathList.push(...newPathList);
    // modelPathList 去重
    modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
}
/**
 * @Description: 删除 节点
 * @param {*} nodeId  被删除的 节点id
 * @param {*} modelPathList
 * @param {*} nodeList
 * @param {*} linkList
 * @return {*}
 */
export function deleteNode({ nodeId, modelPathList, nodeList, linkList }) {
    // 删除的节点是否在合并内
    const isInMerge = isNodeInMerge({ nodeId, modelPathList, nodeList });
    const node = findNodeById({ nodeId, nodeList });
    if (isInMerge) {
        // 判断后一个节点是否是合并节点 && 前一个节点是否为fatherNode  不需要拼接link
        const startLink = findLinkByStartId({ nodeId, linkList });
        const nextNodeActiveId = startLink.meta.activeId;
        if (nextNodeActiveId !== -1) {
            // if (node.meta.extParam.dropTop || node.meta.extParam.dropBottom) {
            //   findNodeMergePathList({nodeId, modelPathList, nodeList, linkList, nextNodeActiveId})
            // }
            // 找fatherNode
            // 获取需要删除的链路集合（未处理链路前的）
            const mergeNodeId = startLink.endId;
            const tempNodeIds = [];
            linkList.forEach(item => {
                if (item.endId === mergeNodeId) {
                    tempNodeIds.push(item.startId);
                }
            });
            // 经过合并节点的链路，截取合并节点其前面的链路集合(不含合并)
            const tempAllTodoPath = [];
            // 经过合并节点的链路，截取合并节点其后续的链路集合(不含合并)
            let tempAllSubPath = [];
            modelPathList.forEach(path => {
                if (path.includes(mergeNodeId)) {
                    tempAllTodoPath.push(path.slice(0, path.findIndex(item => mergeNodeId === item)));
                }
                if (path.includes(nodeId)) {
                    const mergeIndex = path.findIndex(item => mergeNodeId === item);
                    tempAllSubPath.push(...path.slice(mergeIndex + 1));
                }
            });
            tempAllSubPath = Array.from(new Set(tempAllSubPath));
            let intersectionNodeIds = tempAllTodoPath[0];
            for (let i = 1; i < tempAllTodoPath.length; i++) {
                const path = tempAllTodoPath[i];
                intersectionNodeIds = _.intersectionWith(intersectionNodeIds, path, _.isEqual);
            }
            // 上一个环节的起点
            const fatherId = intersectionNodeIds[intersectionNodeIds.length - 1];
            let deleteFlag = false;
            const endLink = findLinkByEndId({ nodeId, linkList });
            modelPathList.forEach(path => {
                const _arr = _.intersectionWith(tempAllSubPath, path, _.isEqual);
                // 不经过前一个节点 && 与后续节点有交集（经过后续节点）
                if (path.includes(endLink.startId) && !path.includes(nodeId) && _arr.length) {
                    deleteFlag = true;
                }
            });
            if (deleteFlag) {
                // 需要判断当前合并有多少个节点
                const mergeLink = linkList.filter(item => item.meta.activeId === nextNodeActiveId);
                // 删除 当前节点，前后连线，链路
                // 删除link,node,modelPath, 不需要拼接link
                linkList.splice(linkList.findIndex(item => item.id === startLink.id), 1);
                linkList.splice(linkList.findIndex(item => item.id === endLink.id), 1);
                // 删除node
                nodeList.splice(nodeList.findIndex(item => item.id === nodeId), 1);
                // 更改modelPath
                modelPathList.forEach(path => {
                    const pathIndex = path.findIndex(item => item === nodeId);
                    if (pathIndex !== -1) {
                        path.splice(pathIndex);
                    }
                });
                if (mergeLink.length === 2) {
                    // 需要把合并节点也删除
                    // deleteNode({ nodeId: mergeLink[0].endId, modelPathList, nodeList, linkList });
                    // mergeLink中startId!==nodeId的另一条删除，找到合并后的另一条线，接过去，把合并节点删除
                    const otherLink = mergeLink.find(item => item.startId !== nodeId);
                    const tempArr = findChildrenNodeList({
                        nodeId: otherLink.endId,
                        modelPathList,
                        nodeList,
                    });
                    tempArr.forEach(item => {
                        item.coordinate[0] -= MERGE_X_GAP / 2;
                    });
                    // 删除 mergeNode
                    nodeList.splice(nodeList.findIndex(item => item.id === otherLink.endId), 1);
                    linkList.splice(linkList.findIndex(item => item.id === otherLink.id), 1);
                    // 拼接link
                    linkList.forEach(item => {
                        if (item.startId === otherLink.endId) {
                            item.startId = otherLink.startId;
                            item.startAt = [240, 50];
                        }
                    });
                    // 更改modelPath
                    modelPathList.forEach(path => {
                        const pathIndex = path.findIndex(item => item === otherLink.endId);
                        if (pathIndex !== -1) {
                            path.splice(pathIndex, 1);
                        }
                    });
                    // 偏移节点 mergeNode后的节点 ？？
                }
                // 将只剩下的起始节点的链路全部删除
                for (let i = modelPathList.length - 1; i >= 0; i--) {
                    const path = modelPathList[i];
                    if (path.length <= 1) {
                        modelPathList.splice(i, 1);
                    }
                }
                modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
            }
            else {
                if (endLink.startId === fatherId) {
                    const mergeNodeList = linkList.filter(item => item.meta.activeId === nextNodeActiveId);
                    if (mergeNodeList.length === 2) {
                        cancelMerge({ selectLinkList: mergeNodeList, nodeList, linkList, modelPathList });
                        deleteNode({ nodeId, modelPathList, nodeList, linkList });
                    }
                    else {
                        // 删除link,node,modelPath, 不需要拼接link
                        linkList.splice(linkList.findIndex(item => item.id === startLink.id), 1);
                        linkList.splice(linkList.findIndex(item => item.id === endLink.id), 1);
                        // 删除node
                        nodeList.splice(nodeList.findIndex(item => item.id === nodeId), 1);
                        // 更改modelPath
                        modelPathList.forEach(path => {
                            const pathIndex = path.findIndex(item => item === nodeId);
                            if (pathIndex !== -1) {
                                path.splice(pathIndex);
                            }
                        });
                        // 将只剩下的起始节点的链路全部删除
                        for (let i = modelPathList.length - 1; i >= 0; i--) {
                            const path = modelPathList[i];
                            if (path.length <= 1) {
                                modelPathList.splice(i, 1);
                            }
                        }
                        modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
                    }
                }
                else {
                    // 删除link，拼接link
                    const allNextLink = [];
                    linkList.forEach(item => {
                        if (item.startId === nodeId) {
                            allNextLink.push(item);
                        }
                    });
                    const endLink = findLinkByEndId({ nodeId: node.id, linkList });
                    const prevNodeId = endLink.startId;
                    allNextLink.forEach(item => {
                        const endNode = findNodeById({ nodeId: item.endId, nodeList });
                        item.meta?.stationPoint?.push([
                            endNode.coordinate[0] - node.coordinate[0],
                            endNode.coordinate[1] - (node.coordinate[1] + NODE_HEADER / 2),
                            // endNode.coordinate[1],
                        ]);
                        item.meta?.stationPoint?.sort((a, b) => a[0] - b[0]);
                        item.startId = prevNodeId;
                    });
                    const linkIndex = linkList.findIndex(item => item.id === endLink.id);
                    linkList.splice(linkIndex, 1);
                    // 删除node
                    nodeList.splice(nodeList.findIndex(item => item.id === nodeId), 1);
                    // 更改modelPath
                    modelPathList.forEach(path => {
                        const pathIndex = path.findIndex(item => item === nodeId);
                        if (pathIndex !== -1) {
                            path.splice(pathIndex, 1);
                        }
                    });
                    modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
                }
            }
        }
        else {
            // 删除link
            const allNextLink = [];
            linkList.forEach(item => {
                if (item.startId === nodeId) {
                    allNextLink.push(item);
                }
            });
            const endLink = findLinkByEndId({ nodeId: node.id, linkList });
            const prevNodeId = endLink.startId;
            allNextLink.forEach(item => {
                const endNode = findNodeById({ nodeId: item.endId, nodeList });
                item.meta?.stationPoint?.push([
                    endNode.coordinate[0] - node.coordinate[0],
                    0,
                    // endNode.coordinate[1] - node.coordinate[1],
                ]);
                item.meta?.stationPoint?.sort((a, b) => a[0] - b[0]);
                item.startId = prevNodeId;
            });
            const linkIndex = linkList.findIndex(item => item.id === endLink.id);
            linkList.splice(linkIndex, 1);
            // 更改modelPathList
            modelPathList.forEach(path => {
                const pathIndex = path.findIndex(item => item === nodeId);
                if (pathIndex !== -1) {
                    path.splice(pathIndex, 1);
                }
            });
            modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
        }
    }
    else {
        // 判断有无后续节点
        const allNextNodeIds = [];
        const allNextLink = [];
        linkList.forEach(item => {
            if (item.startId === nodeId) {
                allNextLink.push(item);
                allNextNodeIds.push(item.endId);
            }
        });
        if (allNextNodeIds.length) {
            // 有后续节点(子孙节点x偏移)
            const childrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
            const minNextX = allNextNodeIds.reduce((min, item) => {
                const nodeItem = findNodeById({ nodeId: item, nodeList });
                if (min > nodeItem.coordinate[0]) {
                    min = nodeItem.coordinate[0];
                }
                return min;
            }, +Infinity);
            const moveX = minNextX - node.coordinate[0];
            // 删除node
            const index = nodeList.findIndex(item => item.id === nodeId);
            nodeList.splice(index, 1);
            // 修改坐标
            childrenList.forEach(item => {
                if (item.id !== nodeId) {
                    item.coordinate[0] -= moveX;
                }
            });
            // 删除link
            const endLink = findLinkByEndId({ nodeId: node.id, linkList });
            const prevNodeId = endLink.startId;
            allNextLink.forEach(item => {
                item.startId = prevNodeId;
            });
            const linkIndex = linkList.findIndex(item => item.id === endLink.id);
            linkList.splice(linkIndex, 1);
            // 更改modelPathList
            modelPathList.forEach(path => {
                const pathIndex = path.findIndex(item => item === nodeId);
                if (pathIndex !== -1) {
                    path.splice(pathIndex, 1);
                }
            });
            modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
        }
        else {
            // 无后续节点 && 上一个节点有多个子节点(y偏移)
            const endLink = findLinkByEndId({ nodeId: node.id, linkList });
            const prevNodeId = endLink.startId;
            const prevAllNextNodeIds = [];
            linkList.forEach(item => {
                if (item.startId === prevNodeId) {
                    prevAllNextNodeIds.push(item.endId);
                }
            });
            if (prevAllNextNodeIds.length >= 2) {
                // 存在更下方的同级节点 偏移y
                nodeList.forEach(item => {
                    if (item.coordinate[1] > node.coordinate[1] + NODE_HEADER / 2) {
                        item.coordinate[1] -= node.height + Y_GAP;
                    }
                });
            }
            // 删除node
            const index = nodeList.findIndex(item => item.id === nodeId);
            nodeList.splice(index, 1);
            // 删除link
            cleanExtraLink({ nodeList, linkList });
            // 更改modelPathList
            modelPathList.forEach(path => {
                const pathIndex = path.findIndex(item => item === nodeId);
                if (pathIndex !== -1) {
                    path.splice(pathIndex, 1);
                }
            });
            // 将只剩下的起始节点的链路全部删除
            for (let i = modelPathList.length - 1; i >= 0; i--) {
                const path = modelPathList[i];
                if (path.length <= 1) {
                    modelPathList.splice(i, 1);
                }
            }
            if (!modelPathList.length) {
                // 若空，则需要置为默认值
                modelPathList.splice(0, modelPathList.length, [nodeList[0].id]);
            }
            modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
        }
    }
}
// export function deleteNode({ nodeId, modelPathList, nodeList, linkList }) {
//   const node = findNodeById({ nodeId, nodeList });
//   // 未处理的链路  临时变量
//   const _tempModelPathList = JSON.parse(JSON.stringify(modelPathList));
//   // 需要被删除的节点 集合
//   const childrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
//   const childrenIds = childrenList.map(child => child.id);
//   // const maxY = calcMaxY(childrenList);
//   // const baseOffsetY = maxY.bottom - (node.height + node.coordinate[1]);
//   // let extraOffsetY = 0;
//   const endLink = findLinkByEndId({ nodeId: node.id, linkList });
//   // 上一个节点
//   const prevNode = findNodeByLink({ link: endLink, nodeList }).start;
//   // 判断 prevNode 是否被其他节点复用
//   let isPrevNodeMult = false;
//   modelPathList.forEach(path => {
//     if (path.includes(prevNode.id)) {
//       //  当前节点所在的位置
//       if (!path.includes(nodeId)) {
//         isPrevNodeMult = true;
//       }
//     }
//   });
//   // if (isPrevNodeMult) {
//   //   extraOffsetY = Y_GAP + node.height;
//   // }
//   // const moveY = baseOffsetY + extraOffsetY;
//   // 删除 所有需要被删除的节点
//   for (let i = nodeList.length - 1; i >= 0; i--) {
//     const nodeItem = nodeList[i];
//     if (childrenIds.includes(nodeItem.id)) {
//       nodeList.splice(i, 1);
//     }
//   }
//   // 找到删除后，上下的两个节点
//   // y坐标大于nodeId.y 的node集合
//   const otherUpperNodeList = nodeList.filter(
//     item =>
//       item.coordinate[1] <= node.coordinate[1] + NODE_HEADER / 2 &&
//       item?.meta?.configKey !== 'start_node',
//   );
//   // nodeY1 为 otherUpperNodeList 中 y+height 最大值
//   let nodeY1 = null;
//   let nodeY1Max = -Infinity;
//   // 分割线
//   let divisionHeight = 0;
//   otherUpperNodeList.forEach(item => {
//     // 计算分割线
//     if (item.coordinate[1] + item.height > divisionHeight) {
//       divisionHeight = item.coordinate[1] + item.height;
//     }
//     // 计算nodeY1
//     // if (!item.meta.extParam.isMergeNode && item.coordinate[1] + item.height > nodeY1Max) {
//     if (item.coordinate[1] + item.height > nodeY1Max) {
//       nodeY1Max = item.coordinate[1] + item.height;
//       nodeY1 = item;
//     }
//   });
//   const otherUnderNodeList = nodeList.filter(
//     item => item.coordinate[1] > node.coordinate[1] + NODE_HEADER / 2,
//   );
//   otherUnderNodeList.sort((a, b) => a.coordinate[1] - b.coordinate[1]);
//   const nodeY2 = otherUnderNodeList.length ? otherUnderNodeList[0] : null;
//   let baseOffsetY = 0;
//   let extraOffsetY = 0;
//   if (nodeY1 === null) {
//     baseOffsetY = nodeY2 ? nodeY2.coordinate[1] : 0;
//     extraOffsetY = 0;
//   } else {
//     // 计算需要偏移的y值
//     if (nodeY2) {
//       baseOffsetY = nodeY2.coordinate[1] - (nodeY1.coordinate[1] + nodeY1.height + Y_GAP);
//       if (isPrevNodeMult) {
//         if (
//           (!nodeY1.meta.extParam.isMergeNode && nodeY1.coordinate[1] === node.coordinate[1]) ||
//           (nodeY1.meta.extParam.isMergeNode &&
//             nodeY1.coordinate[1] - NODE_HEADER / 2 === node.coordinate[1])
//         )
//           extraOffsetY = Y_GAP + nodeY1.height;
//       }
//     }
//   }
//   let moveY = baseOffsetY + extraOffsetY;
//   if (moveY < 0) {
//     moveY = 0;
//   }
//   nodeList.forEach(nodeItem => {
//     if (nodeItem.coordinate[1] > divisionHeight) {
//       nodeItem.coordinate[1] = nodeItem.coordinate[1] - moveY;
//     }
//   });
//   /** 处理 链路 START */
//   for (let i = modelPathList.length - 1; i >= 0; i--) {
//     const path = modelPathList[i];
//     // 判断是否需要处理
//     const intersectionNodeIds = _.intersectionWith(childrenIds, path, _.isEqual);
//     if (intersectionNodeIds.length) {
//       // 需要将相交部分删除
//       for (let j = path.length - 1; j >= 0; j--) {
//         if (intersectionNodeIds.includes(path[j])) {
//           path.splice(j, 1);
//         }
//       }
//     }
//   }
//   // modelPathList 去重
//   modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
//   // 将只剩下的起始节点的链路全部删除
//   for (let i = modelPathList.length - 1; i >= 0; i--) {
//     const path = modelPathList[i];
//     if (path.length <= 1) {
//       modelPathList.splice(i, 1);
//     }
//   }
//   const subsetList = [];
//   // 删除子集  双遍历
//   for (let i = 0; i < modelPathList.length; i++) {
//     const targetPath = modelPathList[i];
//     for (let j = 0; j < modelPathList.length; j++) {
//       const path = modelPathList[j];
//       if (i !== j && containsAll(path, targetPath)) {
//         // 若为其他路线的子集，则标记该链路的下标
//         subsetList.push(i);
//         break;
//       }
//     }
//   }
//   for (let i = modelPathList.length - 1; i >= 0; i--) {
//     if (subsetList.includes(i)) {
//       modelPathList.splice(i, 1);
//     }
//   }
//   if (!modelPathList.length) {
//     // 若空，则需要置为默认值
//     modelPathList.splice(0, modelPathList.length, [nodeList[0].id]);
//   }
//   /** 处理 链路 END */
//   /** 处理 link START */
//   cleanExtraLink({ nodeList, linkList });
//   /** 处理 link END */
//   // 获取需要删除的链路集合（未处理链路前的）
//   const tempAllTodoPath = [];
//   _tempModelPathList.forEach(path => {
//     const lastNodeId = path[path.length - 1];
//     if (childrenIds.includes(lastNodeId)) {
//       tempAllTodoPath.push(path);
//     }
//   });
//   let intersectionNodeIds = tempAllTodoPath[0];
//   for (let i = 1; i < tempAllTodoPath.length; i++) {
//     const path = tempAllTodoPath[i];
//     intersectionNodeIds = _.intersectionWith(intersectionNodeIds, path, _.isEqual);
//   }
//   intersectionNodeIds = intersectionNodeIds.filter(item => !childrenIds.includes(item));
//   // 上一个环节的起点
//   const fatherId = intersectionNodeIds[intersectionNodeIds.length - 1];
//   // 链路处理过后， 经过fatherId的链路（不包括fatherId）
//   const allTodoPath = [];
//   modelPathList.forEach(item => {
//     const i = item.findIndex(id => id === fatherId);
//     if (i !== -1) {
//       allTodoPath.push(item.slice(i + 1));
//     }
//   });
//   const nodeIdActiveMap = getNodeIdActiveMap({ nodeList, linkList });
//   const map = new Map();
//   allTodoPath.forEach(item => {
//     // 倒序遍历
//     for (let i = item.length - 1; i >= 0; i--) {
//       const activeId = nodeIdActiveMap.get(item[i]) || -1;
//       if (activeId !== -1) {
//         if (map.has(activeId)) {
//           map.set(activeId, Array.from(new Set([...map.get(activeId), ...item])));
//         } else {
//           map.set(activeId, [...item]);
//         }
//         break;
//       }
//     }
//   });
//   let canAddNodeIds = [];
//   // 遍历map， 找到y值最大的节点， 该节点即为链路最下方的起始节点
//   for (const [key, item] of map.entries()) {
//     let maxY = 0;
//     let tempNode = null;
//     const canAddNodePathList = [];
//     item.forEach(ele => {
//       const _node = findNodeById({ nodeId: ele, nodeList });
//       if (_node.coordinate[1] > maxY) {
//         maxY = _node.coordinate[1];
//         tempNode = _node;
//       }
//     });
//     // 合并activeId对应的endId的节点
//     const finalNodeId = linkList.find(l => l.meta.activeId === key)?.endId;
//     allTodoPath.forEach(e => {
//       if (e.includes(tempNode.id) && e.includes(finalNodeId)) {
//         canAddNodePathList.push(e);
//         // canAddNodePathListMaxLength = Math.max(canAddNodePathListMaxLength, e.length);
//       }
//     });
//     const arr = findBottomPathFromPathList({ nodeList, modelPathList: canAddNodePathList });
//     if (arr.length) {
//       canAddNodeIds.push(...arr);
//     }
//     // tempNode 就是 起点， 终点：
//     // const path = allTodoPath.find(element => element.includes(tempNode.id));
//     // canAddNodeIds.push(...path);
//   }
//   // 去重
//   canAddNodeIds = Array.from(new Set(canAddNodeIds));
//   // 遍历，将link和node的canAdd置为true
//   canAddNodeIds.forEach(item => {
//     const node = findNodeById({ nodeId: item, nodeList });
//     node.meta.extParam.canAdd = true;
//   });
//   const canAddNodeAndFatherIds = [fatherId, ...canAddNodeIds];
//   linkList.forEach(item => {
//     if (
//       canAddNodeAndFatherIds.includes(item.startId) &&
//       canAddNodeAndFatherIds.includes(item.endId)
//     ) {
//       item.meta.canAdd = true;
//     }
//   });
// }
/**
 * @Description: 合并 节点
 * @param {*} mergeNodeList  选中需要合并的数组
 * @param {*} nodeList
 * @param {*} linkList
 * @param {*} modelPathList
 * @return {*}
 */
export function mergeNode({ mergeNodeList, nodeList, linkList, modelPathList }) {
    // const flag = checkMergeNodeList({ mergeNodeList, nodeList, modelPathList });
    // if (!flag) {
    //   return;
    // }
    // y值升序的mergeNodeList
    const _mergeNodeList = mergeNodeList.toSorted((a, b) => a.coordinate[1] - b.coordinate[1]);
    const _mergeNodeIds = _mergeNodeList.map(item => item.id);
    let maxX = 0;
    _mergeNodeList.forEach(item => {
        maxX = Math.max(maxX, item.coordinate[0] + item.width);
    });
    const minY = _mergeNodeList[0].coordinate[1];
    const maxY = _mergeNodeList[_mergeNodeList.length - 1].coordinate[1];
    const coordinate = [maxX + MERGE_X_GAP / 2, (minY + maxY + NODE_HEADER) / 2];
    const newNode = new Node({
        width: 0,
        height: 0,
        coordinate,
        meta: new Meta({
            configKey: 'empty',
            extParam: {
                isMergeNode: true,
            },
            mergeNode: true,
        }),
    });
    const newLinkList = [];
    const activeId = new Date().getTime();
    _mergeNodeList.forEach(item => {
        const newLink = new Link({
            startId: item.id,
            endId: newNode.id,
            meta: {
                canAdd: false,
                dropTop: false,
                activeId,
            },
        });
        newLinkList.push(newLink);
        item.meta.extParam.canInsert = false;
    });
    linkList.push(...newLinkList);
    // 获取所有经过 选择节点的链路
    const allMergePath = [];
    modelPathList.forEach(path => {
        const lastNode = path[path.length - 1];
        if (_mergeNodeIds.includes(lastNode)) {
            allMergePath.push(path);
        }
    });
    let intersectionNodeIds = allMergePath[0];
    for (let i = 1; i < allMergePath.length; i++) {
        const path = allMergePath[i];
        intersectionNodeIds = _.intersectionWith(intersectionNodeIds, path, _.isEqual);
    }
    // 上一个环节的起点
    const fatherId = intersectionNodeIds[intersectionNodeIds.length - 1];
    // 找到 上一个环节起点 到 合并后节点中的 所有节点
    let allMergedNodeIds = [];
    allMergePath.forEach(path => {
        const startI = path.findIndex(item => item === fatherId);
        allMergedNodeIds.push(...path.slice(startI + 1));
    });
    allMergedNodeIds = Array.from(new Set(allMergedNodeIds));
    nodeList.forEach(item => {
        if (allMergedNodeIds.includes(item.id)) {
            item.meta.extParam.canAdd = false;
            item.meta.extParam.dropTop = false;
        }
    });
    // 让所有 endId 为 allMergedNodeIds 的 可添加置为false
    linkList.forEach(item => {
        if (allMergedNodeIds.includes(item.endId)) {
            item.meta.canAdd = false;
            item.meta.dropTop = false;
        }
    });
    // 找到allMergedNodeIds中y最大的值
    let tempMaxY = -Infinity;
    let tempNode = null;
    // 根据 y值找到最下方的所有节点
    let bottomNodeIds = [];
    for (const item of allMergedNodeIds) {
        const temp = findNodeById({ nodeId: item, nodeList });
        if (temp.coordinate[1] > tempMaxY) {
            tempMaxY = temp.coordinate[1];
            tempNode = temp;
        }
    }
    const canAddNodePathList = [];
    allMergePath.forEach(e => {
        if (e.includes(tempNode.id)) {
            canAddNodePathList.push(e);
        }
    });
    const arr = findBottomPathFromPathList({ nodeList, modelPathList: canAddNodePathList });
    if (arr.length) {
        bottomNodeIds.push(...arr);
    }
    // const path = allMergePath.find(element => element.includes(tempNode.id));
    // bottomNodeIds.push(...path);
    bottomNodeIds = Array.from(new Set(bottomNodeIds));
    nodeList.forEach(item => {
        if (bottomNodeIds.includes(item.id)) {
            item.meta.extParam.canAdd = true;
        }
    });
    // 让合并最下方的线路 的 可添加置为 true
    linkList.forEach(item => {
        if (bottomNodeIds.includes(item.endId)) {
            item.meta.canAdd = true;
        }
    });
    // 找到allMergedNodeIds中y最小的值
    let tempMinY = Infinity;
    let tempMinNode = null;
    // 根据 y值找到最下方的所有节点
    let topNodeIds = [];
    for (const item of allMergedNodeIds) {
        const temp = findNodeById({ nodeId: item, nodeList });
        if (temp.coordinate[1] < tempMinY) {
            tempMinY = temp.coordinate[1];
            tempMinNode = temp;
        }
    }
    const dragNodePathList = [];
    allMergePath.forEach(e => {
        if (e.includes(tempMinNode.id)) {
            dragNodePathList.push(e);
        }
    });
    const topList = findTopPathFromPathList({ nodeList, modelPathList: dragNodePathList });
    if (topList.length) {
        topNodeIds.push(...topList);
    }
    topNodeIds = Array.from(new Set(topNodeIds));
    nodeList.forEach(item => {
        if (topNodeIds.includes(item.id)) {
            item.meta.extParam.dropTop = true;
        }
    });
    // 让合并最下方的线路 的 可添加置为 true
    linkList.forEach(item => {
        if (topNodeIds.includes(item.endId)) {
            item.meta.dropTop = true;
        }
    });
    nodeList.push(newNode);
    // 更新链路
    modelPathList.forEach(path => {
        const lastNode = path[path.length - 1];
        if (_mergeNodeIds.includes(lastNode)) {
            path.splice(path.length, 0, newNode.id);
        }
    });
}
// 删除合并
export function cancelMerge({ selectLinkList, nodeList, linkList, modelPathList }) {
    // const selectLinkList = linkList.map(item => selectLinkIdList.includes(item.id));
    const mergeNode = findNodeById({ nodeId: selectLinkList[0].endId, nodeList });
    // 把 mergeNode 移除，然后把 mergeNode 之后的节点
    const nodeId = mergeNode.id;
    let mergeNodeChildrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
    mergeNodeChildrenList = mergeNodeChildrenList.filter(item => item.id !== nodeId);
    if (!mergeNodeChildrenList.length) {
        // 合并节点后续无其他节点
        deleteNode({ nodeId, modelPathList, nodeList, linkList });
    }
    else {
        // 合并节点后续有其他节点，将后续仅保留最上方的一条
        const selectNodeIds = selectLinkList.map(item => item.startId);
        const selectNodeList = selectNodeIds.map(item => {
            return findNodeById({ nodeId: item, nodeList });
        });
        const topNode = selectNodeList.reduce((node, item) => {
            if (node === null) {
                node = item;
            }
            else {
                if (node.coordinate[1] > item.coordinate[1]) {
                    node = item;
                }
            }
            return node;
        }, null);
        // 偏移距离
        const moveY = mergeNode.coordinate[1] - (topNode.coordinate[1] + NODE_HEADER / 2);
        // 除去最上方节点的其余 selectNodeList 链路后续删除
        const otherSelectNodeIds = selectNodeIds.filter(item => item !== topNode.id);
        // modelPathList中 删除其他下方节点的后续链路
        otherSelectNodeIds.forEach(item => {
            modelPathList.forEach(path => {
                const index = path.findIndex(el => el === item);
                if (index !== -1) {
                    path.splice(index + 1);
                }
            });
        });
        // modelPathList中 删除仅剩的最上方节点的合并节点的链路
        modelPathList.forEach(path => {
            const index = path.findIndex(el => el === mergeNode.id);
            if (index !== -1) {
                path.splice(index, 1);
            }
        });
        // modelPathList 去重
        modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
        // nodeList中 删除合并节点
        const mergeNodeIndex = nodeList.findIndex(item => item.id === nodeId);
        nodeList.splice(mergeNodeIndex, 1);
        // 更改 mergeNodeChildrenList 的 y 值
        mergeNodeChildrenList.forEach(item => {
            item.coordinate[0] -= MERGE_X_GAP / 2;
            item.coordinate[1] -= moveY;
            // if (item.coordinate[1] < mergeNode.coordinate[1]) {
            //   item.coordinate[1] -= moveY;
            // }
        });
        const mergeNodeChildrenIds = mergeNodeChildrenList.map(item => item.id);
        // selectNode 中 找上方离mergeNode最近的节点  下方离mergeNode最近的节点 得出移动距离
        const nearUpperNodeList = selectNodeList.filter(item => item.coordinate[1] <= mergeNode.coordinate[1]);
        nearUpperNodeList.sort((a, b) => b?.coordinate[1] - a?.coordinate[1]);
        const nearUpperNode = nearUpperNodeList[0];
        const nearUnderNodeList = selectNodeList.filter(item => item.coordinate[1] > mergeNode.coordinate[1]);
        nearUnderNodeList.sort((a, b) => a?.coordinate[1] - b?.coordinate[1]);
        const nearUnderNode = nearUnderNodeList[0];
        nodeList.forEach(item => {
            if (item.coordinate[1] > mergeNode.coordinate[1] && !mergeNodeChildrenIds.includes(item.id)) {
                item.coordinate[1] -=
                    nearUnderNode.coordinate[1] -
                        (nearUpperNode.coordinate[1] + nearUpperNode.height + Y_GAP);
            }
        });
        const mergeNodeChildrenMaxY = calcMaxY(mergeNodeChildrenList);
        const diffY = mergeNodeChildrenMaxY.bottom - (topNode.coordinate[1] + topNode.height);
        nodeList.forEach(item => {
            if (item.coordinate[1] > topNode.coordinate[1] + topNode.height + NODE_HEADER / 2 &&
                !mergeNodeChildrenIds.includes(item.id)) {
                item.coordinate[1] += diffY;
            }
        });
        // const flag = selectNodeList.some(item => {
        //   return item.id !== topNode.id && item.coordinate[1] < mergeNode.coordinate[1];
        // });
        // if (flag) {
        //   nodeList.forEach(item => {
        //     if (
        //       item.coordinate[1] > topNode.coordinate[1] + topNode.height + NODE_HEADER / 2 &&
        //       !mergeNodeChildrenIds.includes(item.id)
        //     ) {
        //       item.coordinate[1] += diffY;
        //     }
        //   });
        // }
        const newLinkEndIdList = [];
        /**
         * linkList中 删除startId为mergeNodeId的所有link删除(同时记录所有endId)
         * linkList中 删除endId为mergeNodeId的所有link删除
         */
        for (let i = linkList.length - 1; i >= 0; i--) {
            const item = linkList[i];
            if (item.startId === nodeId) {
                newLinkEndIdList.push(item.endId);
                linkList.splice(i, 1);
            }
            else if (item.endId === nodeId) {
                linkList.splice(i, 1);
            }
        }
        // 新建link startId为topNodeId, endId为 之前记录的endId
        newLinkEndIdList.forEach(item => {
            const newLink = new Link({
                startId: topNode.id,
                endId: item,
            });
            linkList.push(newLink);
        });
    }
}
// 组装展开收起后的数据
export function initShrinkNode({ nodeList, modelPathList }) {
    // 收起的node集合
    const shrinkNodes = nodeList.reduce((prev, cur) => {
        if (!cur.meta.extParam.isOpen) {
            return [...prev, cur.id];
        }
        return prev;
    }, []);
    const renderPathList = modelPathList.map(item => {
        if (item.every(ele => !shrinkNodes.includes(ele))) {
            // 不经过该节点，则不处理
            return item;
        }
        else {
            // 经过该节点，则截取该节点前的数据
            const index = item.findIndex(nodeId => shrinkNodes.includes(nodeId));
            return item.slice(0, index + 1);
        }
    });
    let renderNodeIds = [];
    // 根据renderPathList获取所有要渲染的节点renderNodeIds
    renderPathList.forEach(item => {
        item.forEach(element => {
            renderNodeIds.push(element);
        });
    });
    renderNodeIds = Array.from(new Set(renderNodeIds));
    // 获取所有要渲染的节点
    const renderNodeList = nodeList.filter(item => renderNodeIds.includes(item.id));
    const dragElement = nodeList.find(n => n.meta?.extParam.isDragElement);
    if (dragElement) {
        renderNodeList.push(dragElement);
    }
    return renderNodeList;
}
// 展开收起 节点
export function shrinkOrExpandNode({ nodeId, nodeList, modelPathList }) {
    const node = findNodeById({ nodeId, nodeList });
    const childrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
    // 修改前的 isOpen状态
    const toOpen = !node.meta.extParam.isOpen;
    // isOpen 置反
    node.meta.extParam.isOpen = toOpen;
    // 收起的node集合
    const shrinkIds = nodeList.reduce((prev, cur) => {
        if (!cur.meta.extParam.isOpen) {
            return [...prev, cur.id];
        }
        return prev;
    }, []);
    // 被收起|展开的节点（不包含点击的节点）
    let childrenOpenIds = [];
    for (const item of modelPathList) {
        // 不经过该节点，则不处理
        if (item.includes(nodeId)) {
            const curIndex = item.findIndex(ele => ele === nodeId);
            const newList = item.slice(curIndex + 1);
            const nextIndex = newList.findIndex(ele => shrinkIds.some(a => a === ele));
            const curToNextPathList = newList.slice(0, nextIndex !== -1 ? nextIndex + 1 : newList.length);
            childrenOpenIds.push(...curToNextPathList);
        }
    }
    // 去重
    childrenOpenIds = Array.from(new Set(childrenOpenIds));
    const childrenOpenNodeList = nodeList.filter(item => childrenOpenIds.includes(item.id));
    const maxY = calcMaxY(childrenOpenNodeList);
    const otherUpperNodeList = nodeList.filter(item => !childrenOpenIds.includes(item.id) &&
        item.coordinate[1] <= node.coordinate[1] + NODE_HEADER / 2);
    // nodeY1 为 otherUpperNodeList 中 y+height 最大值
    let nodeY1Max = NODE_HEADER / 2;
    otherUpperNodeList.forEach(item => {
        if (item.coordinate[1] + item.height > nodeY1Max) {
            nodeY1Max = item.coordinate[1] + item.height;
        }
    });
    // const curNodeY = node.coordinate[1];
    // 要偏移的y值
    const offsetY = maxY.bottom - nodeY1Max;
    if (offsetY <= 0) {
        return;
    }
    // 收起时拿子孙节点y最大的去对比，展开是拿当前节点
    // const top = toOpen ? nodeY1Max : maxY.top;
    const top = nodeY1Max;
    // 剩余节点集合（除子孙节点外）;且y坐标比收起节点要大的
    const shrinkNodePathNodeList = nodeList.filter(item => {
        const flag = item.coordinate[1] > top;
        return childrenList.every(ele => item.id !== ele.id) && flag;
    });
    for (const item of shrinkNodePathNodeList) {
        item.coordinate[1] = !toOpen ? item.coordinate[1] - offsetY : item.coordinate[1] + offsetY;
    }
}
// 更改节点高度
export function changeNodeHeight({ nodeId, nodeList, diffY }) {
    if (diffY === 0) {
        return;
    }
    const node = findNodeById({ nodeId, nodeList });
    const nodeY = node.coordinate[1];
    const nodeBottom = nodeY + node.height;
    // 遍历nodeList
    const yNodeList = nodeList.filter(item => {
        return (nodeY === item.coordinate[1] && node.id !== item.id && item?.meta?.configKey !== 'start_node');
    });
    const maxY = calcMaxY(yNodeList);
    if ((diffY > 0 && maxY.bottom <= nodeBottom) || (diffY < 0 && maxY.bottom < nodeBottom)) {
        nodeList.forEach(item => {
            if (item.coordinate[1] > nodeY + NODE_HEADER / 2) {
                item.coordinate[1] += diffY;
            }
        });
    }
}
/**
 * 根据元素坐标来查询目标节点 也就是要插入在哪个节点附近，找到节点后再根据节点的4个角的坐标来判断插入方向（上、下、右三个方向）
 * @param x 水平偏移量
 * @param offset 节点偏移量
 */
export function findNodeByCoordinate({ nodeList, modelPathList, offset = [] }) {
    const filteredDragNodeList = nodeList.filter(node => !node.meta?.extParam?.isDragElement);
    // 页面上展示的渲染节点
    const renderNodeList = initShrinkNode({
        modelPathList,
        nodeList: filteredDragNodeList,
    });
    const [x, y] = offset;
    // 找出离当前节点距离最近的点 用三角函数的方法 x^2+y^2 排序取最小值
    const absX = Math.abs(x);
    const absY = Math.abs(y);
    renderNodeList.sort((prev, curr) => {
        const prevCenterX = prev.width ? prev.coordinate[0] + prev.width / 2 : prev.coordinate[0]; // x中心点
        const prevCenterY = prev.height ? prev.coordinate[1] + prev.height / 2 : prev.coordinate[1]; // y中心点
        const currCenterX = curr.width ? curr.coordinate[0] + curr.width / 2 : curr.coordinate[0]; // x中心点
        const currCenterY = curr.height ? curr.coordinate[1] + curr.height / 2 : curr.coordinate[1]; // y中心点
        const prevDistance = Math.abs(Math.pow(prevCenterX - absX, 2)) + Math.abs(Math.pow(prevCenterY - absY, 2));
        const curDistance = Math.abs(Math.pow(currCenterX - absX, 2)) + Math.abs(Math.pow(currCenterY - absY, 2));
        return prevDistance - curDistance;
    });
    const targetNode = renderNodeList.slice(0, 1)?.[0];
    const isMergeNode = targetNode.meta?.extParam?.isMergeNode;
    const mergeOffset = 20;
    // 插入节点4个端点的坐标
    const targetNodePointCoordinate = [
        {
            // 上 [x1, y1] 下标就是枚举值 Direction
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] - mergeOffset, targetNode.coordinate[1] - mergeOffset]
                : [...targetNode.coordinate],
            direction: Direction.TOP,
        },
        {
            // 右 [x1 + w, y1]
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] + mergeOffset, targetNode.coordinate[1] - mergeOffset]
                : [targetNode.coordinate[0] + targetNode.width, targetNode.coordinate[1]],
            direction: Direction.RIGHT,
        },
        {
            // 下 [x1 + w, y1 + h]
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] + mergeOffset, targetNode.coordinate[1] + mergeOffset]
                : [
                    targetNode.coordinate[0] + targetNode.width,
                    targetNode.coordinate[1] + targetNode.height,
                ],
            direction: Direction.BOTTOM,
        },
        {
            // 左 [x1, y1 + h]
            coordinate: isMergeNode
                ? [targetNode.coordinate[0] - mergeOffset, targetNode.coordinate[1] + mergeOffset]
                : [targetNode.coordinate[0], targetNode.coordinate[1] + targetNode.height],
            direction: Direction.LEFT,
        },
    ];
    targetNodePointCoordinate.sort((prev, curr) => {
        const prevDistance = Math.abs(Math.pow(prev.coordinate[0] - absX, 2)) +
            Math.abs(Math.pow(prev.coordinate[1] - absY, 2));
        const curDistance = Math.abs(Math.pow(curr.coordinate[0] - absX, 2)) +
            Math.abs(Math.pow(curr.coordinate[1] - absY, 2));
        return prevDistance - curDistance;
    });
    // 需要判断是否是最后节点 是最后节点的话 右边只有1个方向
    return {
        node: renderNodeList?.[0],
        direction: targetNodePointCoordinate?.[0]?.direction, // 插入的方向
    };
}
// 节点是否可拖动
export function disabledNodeDrag({ sourceNode, linkList, nodeList, modelPathList, draggable }) {
    if (!draggable)
        return true;
    // 获取源节点的连线
    const sourceLink = findLinkByEndId({ nodeId: sourceNode.id, linkList });
    // 兜底判断 如果是源节点连线不存在则说明是起始节点，那么不可以拖动
    if (!sourceLink)
        return true;
    const isInMerge = isNodeInMerge({ nodeId: sourceNode.id, modelPathList, nodeList });
    if (isInMerge)
        return true;
    if (sourceNode.meta.type === TreeNodeType.TOOLS) {
        if (sourceNode.meta.extParam.toolsIsEdit)
            return true; // 编辑态不允许拖
        // 除自己外是否有其他链路，如果有就可以拖动，没有的话说明没有同级节点
        const otherLinkList = linkList.filter(link => link.startId === sourceLink?.startId && link.endId !== sourceLink?.endId);
        return otherLinkList.length <= 0;
    }
}
// 添加拖动占位节点
export function appendDragNode({ sourceNode, targetNode, nodeList, linkList, modelPathList, direction, }) {
    if (isNodeInMerge({ nodeId: targetNode.id, modelPathList, nodeList })) {
        if (targetNode.meta?.extParam?.canAdd) {
            if (![Direction.LEFT, Direction.BOTTOM].includes(direction)) {
                return { disabled: true };
            }
            else {
                const link = findLinkByStartId({ nodeId: targetNode.id, linkList });
                if (direction === Direction.BOTTOM && link.meta?.activeId !== -1) {
                    return { disabled: true };
                }
            }
        }
        else if (targetNode.meta?.extParam?.dropTop) {
            if (![Direction.TOP, Direction.RIGHT].includes(direction)) {
                return { disabled: true };
            }
            else {
                const link = findLinkByStartId({ nodeId: targetNode.id, linkList });
                if (direction === Direction.RIGHT && link.meta?.activeId !== -1) {
                    return { disabled: true };
                }
            }
        }
        else {
            return { disabled: true };
        }
    }
    const isMergeTargetNode = targetNode?.meta?.extParam?.isMergeNode;
    // 不能拖动到合并内或合并节点上
    if (!sourceNode?.id || (isMergeTargetNode && [Direction.TOP, Direction.LEFT].includes(direction)))
        return { disabled: true };
    const dragNodeIndex = nodeList.findIndex(node => node.meta?.extParam?.isDragElement);
    let dragNodeX = targetNode.coordinate[0];
    let dragNodeY = targetNode.coordinate[1] - Y_DRAG_GAP - DRAG_NODE_HEIGHT; // 默认左上
    let link = findLinkByEndId({ nodeId: targetNode.id, linkList }); // 默认作为结束节点来查询连线 默认TOP
    // 页面上展示的渲染节点
    const renderNodeList = initShrinkNode({
        modelPathList,
        nodeList,
    });
    // 该节点的子孙节点-不包括收起的 目标元素子孙节点
    const renderChildrenList = findChildrenNodeList({
        nodeId: targetNode.id,
        modelPathList,
        nodeList: renderNodeList.filter(node => !node.meta?.extParam?.isDragElement), // 过滤占位节点
    });
    // 源子孙节点
    const sourceRenderChildrenList = findChildrenNodeList({
        nodeId: sourceNode.id,
        modelPathList,
        nodeList: renderNodeList.filter(node => !node.meta?.extParam?.isDragElement), // 过滤占位节点
    });
    let isChildrenNode = false;
    sourceRenderChildrenList.forEach(node => {
        node.meta.extParam.isDragging = true;
        if (node.id === targetNode.id) {
            isChildrenNode = true;
        }
    });
    // 不能拖到自己子孙节点上 也不让拖到开始节点上
    if (isChildrenNode || targetNode.meta?.configKey === 'start_node') {
        deleteDragNodeAndLink({ nodeList, linkList, modelPathList });
        return { disabled: true };
    }
    // 获取拖拽占位节点
    const dragNode = nodeList[dragNodeIndex];
    switch (direction) {
        // 拖动到了节点右边(RIGHT、BOTTOM) 就在下一个节点加入
        case Direction.RIGHT: // 右上
            link = findLinkByStartId({ nodeId: targetNode.id, linkList });
            // 如果不存在则说明是最后节点 需要增加在最后
            if (link && link.endId !== dragNode?.id) {
                dragNodeY = isMergeTargetNode
                    ? targetNode.coordinate[1] - Y_DRAG_GAP - DRAG_NODE_HEIGHT * 2
                    : targetNode.coordinate[1] - Y_DRAG_GAP - Y_DRAG_GAP; // 按照xmind交互 收起也是直接显示在后面
            }
            else {
                dragNodeY = isMergeTargetNode
                    ? targetNode.coordinate[1] - DRAG_NODE_HEIGHT / 2
                    : targetNode.coordinate[1] + DRAG_NODE_HEIGHT / 2;
            }
            dragNodeX = targetNode.coordinate[0] + X_GAP + targetNode.width;
            break;
        case Direction.BOTTOM: // 右下
            link = findLinkByStartId({ nodeId: targetNode.id, linkList });
            dragNodeX = targetNode.coordinate[0] + X_GAP + targetNode.width;
            if (link && link.endId !== dragNode?.id) {
                const maxY = calcMaxY(renderChildrenList);
                dragNodeY = maxY.bottom + Y_DRAG_GAP;
            }
            else {
                dragNodeY = isMergeTargetNode
                    ? targetNode.coordinate[1] - DRAG_NODE_HEIGHT / 2
                    : targetNode.coordinate[1] + DRAG_NODE_HEIGHT / 2;
            }
            break;
        case Direction.LEFT:
            dragNodeX = targetNode.coordinate[0];
            const maxY = calcMaxY(renderChildrenList);
            dragNodeY = maxY.bottom + Y_DRAG_GAP;
            break;
    }
    const nodeObj = link && findNodeByLink({ link, nodeList }); // 查到连线两端的节点
    const startNode = nodeObj ? nodeObj.start : targetNode;
    // 工具的话需要判断是否要处理后续逻辑
    if (sourceNode.meta.type === TreeNodeType.TOOLS) {
        const targetLink = findLinkByEndId({ nodeId: targetNode?.id, linkList });
        const sourceLink = findLinkByEndId({ nodeId: sourceNode?.id, linkList });
        if (!targetLink)
            return { disabeld: true };
        if (sourceLink?.startId === startNode?.id && targetLink?.startId === startNode?.id) {
            //
        }
        else {
            return { disabled: true };
        }
    }
    if (dragNodeIndex > -1) {
        const dragNode = nodeList[dragNodeIndex];
        dragNode.coordinate = [dragNodeX, dragNodeY]; // 更新占位节点坐标
        const dragLinkIndex = linkList.findIndex(link => link.meta?.isDragElement);
        linkList[dragLinkIndex].startId = startNode.id; // 更新开始节点
        linkList[dragLinkIndex].endId = dragNode.id; // 拖拽占位节点不变
        modelPathList.forEach(path => {
            const index = path.indexOf(id => id === startNode.id);
            if (index > -1) {
                const prevPath = path.slice(0, index + 1);
                path.splice(0, path.length, [...prevPath, dragNode.id]);
            }
        });
    }
    else {
        // 创建占位节点 拖动结束后移除
        const newNode = new Node({
            width: 40,
            height: DRAG_NODE_HEIGHT,
            coordinate: [dragNodeX, dragNodeY],
            meta: new Meta({
                extParam: {
                    isDragElement: true,
                    isOpen: false,
                },
            }),
        });
        nodeList.push(newNode);
        // 拖拽时的辅助线
        const newLink = new Link({
            startId: startNode.id,
            endId: newNode.id,
            // endAt: [0, 10],
            meta: {
                isDragElement: true,
            },
        });
        linkList.push(newLink);
        const newPathList = [];
        for (let i = 0; i < modelPathList.length; i++) {
            const path = modelPathList[i];
            const index = path.indexOf(startNode.id);
            if (index > -1) {
                newPathList.push([...path.slice(0, index + 1), newNode.id]);
                break;
            }
        }
        modelPathList.push(...newPathList);
    }
    return {
        startNode,
    };
}
// 删除拖拽节点和连线
export function deleteDragNodeAndLink({ nodeList, linkList, modelPathList }) {
    const dragNodeIndex = nodeList.findIndex(node => node.meta?.extParam?.isDragElement);
    if (dragNodeIndex > -1) {
        const dragNodeId = nodeList[dragNodeIndex].id;
        nodeList.splice(dragNodeIndex, 1);
        const dragLinkIndex = linkList.findIndex(link => link.meta?.isDragElement);
        dragLinkIndex > -1 && linkList.splice(dragLinkIndex, 1);
        const pathIndex = modelPathList.findIndex(path => path.includes(dragNodeId));
        pathIndex > -1 && modelPathList.splice(pathIndex, 1);
    }
}
// 拖拽后更新路径
export function updateDragNode({ sourceNode, startNode, targetNode, nodeList, modelPathList, linkList, direction, disabled, }) {
    if (!targetNode)
        return;
    const isOpen = targetNode?.meta?.extParam?.isOpen;
    // 如果是收起则需要展开
    if (!isOpen) {
        shrinkOrExpandNode({ nodeId: targetNode?.id, nodeList, modelPathList });
        const newSourceNode = nodeList.find(node => node.id === sourceNode?.id);
        sourceNode.coordinate = newSourceNode?.coordinate; // 重新赋值坐标
    }
    // debugger
    // if (sourceNode.id === targetNode.id) return;
    // 页面上展示的渲染节点
    const renderNodeList = initShrinkNode({
        modelPathList,
        nodeList,
    });
    // 源节点的子孙节点-不包括收起的
    const renderChildrenList = findChildrenNodeList({
        nodeId: sourceNode.id,
        modelPathList,
        nodeList: renderNodeList.filter(node => !node.meta?.extParam?.isDragElement), // 过滤占位节点
    });
    // 源节点的子孙节点-包括收起的
    const sourceChildrenList = findChildrenNodeList({
        nodeId: sourceNode.id,
        modelPathList,
        nodeList: nodeList.filter(node => !node.meta?.extParam?.isDragElement), // 过滤占位节点
    });
    let isChildrenNode = false;
    renderChildrenList.forEach(node => {
        node.meta.extParam.isDragging = false;
        if (node.id === targetNode?.id) {
            isChildrenNode = true;
        }
    });
    if (isChildrenNode || !startNode || disabled)
        return;
    // 目标子孙节点 被渲染的
    const targetRenderChildrenList = findChildrenNodeList({
        nodeId: targetNode.id,
        modelPathList,
        nodeList: renderNodeList.filter(node => !node.meta?.extParam?.isDragElement), // 过滤占位节点
    });
    // 目标子孙节点
    const targetChildrenList = findChildrenNodeList({
        nodeId: targetNode.id,
        modelPathList,
        nodeList: nodeList.filter(node => !node.meta?.extParam?.isDragElement), // 过滤占位节点
    });
    // 经过拖拽节点的子孙节点最大y坐标 未收起的
    const sourceRenderMaxY = calcMaxY(renderChildrenList);
    const sourceMaxY = calcMaxY(sourceChildrenList);
    /* ================================ 处理节点 ================================ */
    // 找到源节点的上一个节点是否包含在其他链路中 如果包含则需要修改下方节点的y坐标
    const link = findLinkByEndId({ nodeId: sourceNode.id, linkList });
    const sourceStartNodeId = link.startId;
    const otherPath = modelPathList.filter(path => path.includes(link.startId));
    const isOtherPath = otherPath.length > 1;
    const isSameLevel = linkList.some(item => item.startId === sourceStartNodeId && item.endId !== sourceNode.id);
    // 先处理拖动节点下方的节点坐标 只是添加不是插入 所以不影响x轴
    const diffMaxYAndSourceNodeY = sourceRenderMaxY.bottom - sourceNode.coordinate[1];
    const targetMaxY = calcMaxY(targetRenderChildrenList);
    const targetBottomNodeList = renderNodeList.filter(node => node.coordinate[1] > targetMaxY.bottom &&
        renderChildrenList.findIndex(n => n.id === node.id) < 0);
    // 目标节点及子孙节点 和 源渲染节点及子孙节点之间的差集
    const targetRenderChildrenAndSourceRenderDiffList = targetRenderChildrenList.filter(node => renderChildrenList.findIndex(n => n.id === node.id) < 0);
    const targetChildrenAndSourceDiffList = targetChildrenList.filter(node => renderChildrenList.findIndex(n => n.id === node.id) < 0);
    const targetChildrenAndSourceRenderDiffList = targetRenderChildrenList.filter(node => renderChildrenList.findIndex(n => n.id === node.id) < 0);
    const mergeRenderList = renderNodeList.filter(node => node.coordinate[1] < targetMaxY.bottom &&
        node.coordinate[1] > targetNode.coordinate[1] &&
        targetRenderChildrenList.findIndex(n => n.id === node.id) < 0);
    // 目标节点及子孙节点 和 源渲染节点及子孙节点之间的差集
    const targetRenderChildrenAndSourceDiffList = targetRenderChildrenList.filter(node => renderChildrenList.findIndex(n => n.id === node.id) < 0);
    const originTargetNodeY = targetNode.coordinate[1];
    // 从下往上 需要从当前渲染元素判断 否则下方元素没有收起元素的y大会导致找不到
    let bottomSourceNodeList = renderNodeList.filter(node => node.coordinate[1] > sourceRenderMaxY.bottom);
    let dragDirection = Direction.TOP;
    const horDirection = sourceNode.coordinate[0] > targetNode.coordinate[0] ? 'left' : 'right';
    const isInMerge = isNodeInMerge({ nodeId: targetNode.id, modelPathList, nodeList });
    if (sourceNode.coordinate[1] === targetNode.coordinate[1] &&
        ![Direction.LEFT, Direction.BOTTOM].includes(direction)) {
        // if (![Direction.LEFT, Direction.BOTTOM].includes(direction)) {
        dragDirection = Direction.TOP;
        const maxY = !sourceNode.meta?.extParam?.isOpen ? sourceRenderMaxY.bottom : sourceMaxY.bottom;
        if (direction === Direction.TOP &&
            !sourceNode.meta?.extParam?.isOpen &&
            horDirection === 'left') {
            dragDirection = null;
            bottomSourceNodeList = renderNodeList.filter(node => node.coordinate[1] > sourceRenderMaxY.bottom);
        }
        else {
            bottomSourceNodeList = nodeList.filter(node => node.coordinate[1] > maxY);
        }
        // }
    }
    else {
        const maxY = isInMerge ? targetNode.coordinate[1] : targetMaxY.bottom;
        dragDirection = sourceNode.coordinate[1] < maxY ? Direction.BOTTOM : Direction.TOP;
    }
    // 先修改目标子孙节点以及比目标链路Y坐标大的节点坐标
    switch (direction) {
        case Direction.TOP:
            const diffTopList = !sourceNode.meta.extParam?.isOpen
                ? targetChildrenAndSourceRenderDiffList
                : targetChildrenAndSourceDiffList;
            const res = [...diffTopList, ...targetBottomNodeList];
            if (isInMerge) {
                res.push(...mergeRenderList);
            }
            res.forEach(node => {
                node.coordinate[1] = node.coordinate[1] + diffMaxYAndSourceNodeY + Y_GAP;
            });
            break;
        case Direction.RIGHT:
            const diffRightList = !sourceNode.meta.extParam?.isOpen
                ? targetChildrenAndSourceRenderDiffList
                : targetChildrenAndSourceDiffList;
            const targetNextNodeList = diffRightList?.filter(node => node.id !== targetNode.id);
            const arr = [...targetNextNodeList, ...targetBottomNodeList];
            if (isNodeInMerge({ nodeId: targetNode.id, modelPathList, nodeList })) {
                arr.push(...mergeRenderList);
            }
            arr.forEach(node => {
                node.coordinate[1] =
                    targetNextNodeList.length > 0
                        ? node.coordinate[1] + diffMaxYAndSourceNodeY + Y_GAP
                        : node.coordinate[1] + diffMaxYAndSourceNodeY - sourceNode.height;
            });
            break;
        case Direction.BOTTOM:
            targetBottomNodeList.forEach(node => {
                node.coordinate[1] =
                    targetRenderChildrenAndSourceRenderDiffList.length > 1
                        ? node.coordinate[1] + diffMaxYAndSourceNodeY + Y_GAP
                        : node.coordinate[1] + diffMaxYAndSourceNodeY - sourceNode.height;
            });
            break;
        case Direction.LEFT:
            targetBottomNodeList.forEach(node => {
                node.coordinate[1] = node.coordinate[1] + diffMaxYAndSourceNodeY + Y_GAP;
            });
            break;
    }
    // 修改源坐标（被拖动的节点以及子孙节点坐标）
    const isMergeNode = targetNode?.meta?.extParam?.isMergeNode;
    const originSourceX = sourceNode.coordinate[0];
    const originSourceY = sourceNode.coordinate[1];
    sourceChildrenList.forEach(node => {
        const diffX = node.coordinate[0] - originSourceX;
        const diffY = isMergeNode
            ? node.coordinate[1] - originSourceY - NODE_HEADER / 2
            : node.coordinate[1] - originSourceY;
        // 修改x轴坐标
        node.coordinate[0] =
            ([Direction.LEFT, Direction.TOP].includes(direction)
                ? targetNode.coordinate[0]
                : targetNode.coordinate[0] + targetNode.width + X_GAP) + diffX;
        // 修改y轴坐标
        if ([Direction.TOP, Direction.RIGHT].includes(direction)) {
            node.coordinate[1] = diffY + originTargetNodeY;
        }
        else if (direction === Direction.BOTTOM) {
            const targetNextNodeList = targetRenderChildrenAndSourceDiffList.filter(node => node.id !== targetNode.id);
            node.coordinate[1] =
                targetNextNodeList.length > 0
                    ? diffY + targetMaxY.bottom + Y_GAP
                    : diffY + originTargetNodeY;
        }
        else {
            node.coordinate[1] = diffY + targetMaxY.bottom + Y_GAP;
        }
    });
    // 如果源坐标的前一个节点是与其他链路共同的祖先则需要将源坐标之下的节点坐标全部更新 有可能是重复操作（从下拖动到上）
    if (isOtherPath) {
        // BOTTOM 是从上到下
        if (dragDirection === Direction.BOTTOM) {
            // 从上往下 需要从收起的里面找。否则比渲染Y大的会找不到
            bottomSourceNodeList = nodeList.filter(node => node.coordinate[1] > sourceRenderMaxY.bottom);
        }
        const diffY = isSameLevel
            ? diffMaxYAndSourceNodeY + Y_GAP
            : diffMaxYAndSourceNodeY - sourceNode.height;
        bottomSourceNodeList.forEach(node => {
            node.coordinate[1] = node.coordinate[1] - diffY;
        });
    }
    /* ================================ 处理连线 ================================ */
    const sourceNodeLink = linkList.find(link => link.endId === sourceNode.id);
    sourceNodeLink.startId = startNode.id;
    sourceNodeLink.startAt = [startNode.width, 16];
    /* ================================ 处理链路 ================================ */
    // 处理经过原拖拽节点的所有路径
    const dragPathList = [];
    const startNodeId = startNode.id;
    for (let i = modelPathList.length - 1; i >= 0; i--) {
        const paths = modelPathList[i];
        const index = paths.indexOf(sourceNode.id);
        if (index > -1) {
            dragPathList.push(paths.slice(index)); // 先保存拖拽后的所有路径
            paths.splice(index); // // 再删除原位置上的路径
        }
        if (paths.length <= 1) {
            paths.splice(0);
            modelPathList.splice(i, 1);
        }
    }
    const hasNextNode = linkList.some(link => link?.startId === startNodeId &&
        link?.meta?.activeId === -1 &&
        !link?.meta?.isDragElement &&
        link.endId !== sourceNode.id);
    // 获取经过目标开始节点的所有路径
    const targetNodePathList = modelPathList.filter(paths => paths.includes(startNodeId));
    const newTargetPathList = [];
    for (let i = 0; i < targetNodePathList.length; i++) {
        const targetNodePath = targetNodePathList[i];
        const startNodePathIndex = targetNodePath.indexOf(startNodeId);
        for (let j = 0; j < dragPathList.length; j++) {
            const dragPath = dragPathList[j];
            newTargetPathList.push([...targetNodePath.slice(0, startNodePathIndex + 1), ...dragPath]);
        }
    }
    if (hasNextNode) {
        modelPathList.push(...newTargetPathList);
    }
    else {
        modelPathList.forEach((paths, index) => {
            const startIndex = paths.indexOf(startNodeId);
            if (startIndex > -1) {
                modelPathList.splice(index, 1, ...newTargetPathList);
            }
        });
    }
    modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
    if ([Direction.TOP, Direction.LEFT].includes(direction) && !isOpen) {
        shrinkOrExpandNode({ nodeId: targetNode?.id, nodeList, modelPathList });
    }
}
// 更改节点高度
export function changeNodeWidth({ nodeId, nodeList, modelPathList, width }) {
    const node = findNodeById({ nodeId, nodeList });
    const diffX = width - node.width;
    if (diffX === 0) {
        return;
    }
    const childrenList = findChildrenNodeList({ nodeId, modelPathList, nodeList });
    node.width = width;
    childrenList.forEach(item => {
        if (item.id !== nodeId) {
            item.coordinate[0] += diffX;
        }
    });
}
// 修改合并
export function editMerge({ selectNode, mergeNodeList, activeId, mergeNode, modelPathList, linkList, nodeList, }) {
    // nodeList不需要处理
    let maxX = 0;
    selectNode.forEach(item => {
        maxX = Math.max(maxX, item.coordinate[0] + item.width);
    });
    const diffX = maxX + MERGE_X_GAP / 2 - mergeNode.coordinate[0];
    const mergeNodeChildrenList = findChildrenNodeList({
        nodeId: mergeNode.id,
        modelPathList,
        nodeList,
    });
    if (diffX !== 0) {
        // 合并节点 与 其子节点 x 轴偏移
        mergeNodeChildrenList.forEach(item => {
            item.coordinate[0] += diffX;
        });
    }
    /**
     * linkList处理
     *  遍历 selectNodeList
     *    if (!mergeNodeList.includes(item)) { new Link({ startId: item, endId: mergeNode.id }) }
     *
     *  遍历 mergeNodeList
     *    if (!selectNodeList.includes(item)) { 删除线 }
     */
    const selectNodeIds = selectNode.map(item => item.id);
    const mergeNodeIds = mergeNodeList.map(item => item.id);
    selectNode.forEach(item => {
        if (!mergeNodeIds.includes(item.id)) {
            const newLink = new Link({
                startId: item.id,
                endId: mergeNode.id,
                meta: {
                    activeId,
                },
            });
            linkList.push(newLink);
        }
    });
    mergeNodeList.forEach(item => {
        if (!selectNodeIds.includes(item.id)) {
            const index = linkList.findIndex(link => {
                return link.startId === item.id && link.endId === mergeNode.id;
            });
            linkList.splice(index, 1);
        }
    });
    /**
     * modelPathList 处理
     *  先找到 包含 mergeNode 的链路，并且 截取[mergeNode.id, 最后]， 然后去重得到 tempPathList
     *  遍历 selectNodeList
     *    if (!mergeNodeList.includes(item)) {
     *      找到item 的链路， 将item的链路拼接上 [xxx, ...tempPathList]
     *    }
     *
     *  遍历 mergeNodeList
     *    if (!selectNodeList.includes(item)) {
     *      找到item 的链路， 将item的链路截取到 item
     *    }
     *
     * 去重modelPathList
     */
    const tempPathList = [];
    modelPathList.forEach(path => {
        const index = path.findIndex(item => item === mergeNode.id);
        if (index !== -1) {
            tempPathList.push(path.slice(index));
        }
    });
    tempPathList.splice(0, tempPathList.length, ...drop2DArrayDuplicate(tempPathList));
    selectNode.forEach(item => {
        if (!mergeNodeIds.includes(item.id)) {
            modelPathList.forEach(path => {
                if (path.includes(item.id)) {
                    tempPathList.forEach(el => {
                        path.splice(path.length, 0, ...el);
                    });
                }
            });
        }
    });
    mergeNodeList.forEach(item => {
        if (!selectNodeIds.includes(item.id)) {
            modelPathList.forEach(path => {
                const index = path.findIndex(e => e === item.id);
                if (index !== -1) {
                    path.splice(index + 1);
                }
            });
        }
    });
    // modelPathList 去重
    modelPathList.splice(0, modelPathList.length, ...drop2DArrayDuplicate(modelPathList));
}
